<template>
  <div>
    <v-card outlined class="grey lighten-4 pa-2" tile>
      <v-card-title>Übersicht</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="8">
            <span class="font-weight-bold">Zwischensumme: </span>
          </v-col>
          <v-col cols="4" class=" text-right">
            <span class="font-weight-bold">{{ sum }} €</span>
          </v-col>
          <v-col cols="8">
            <span style="font-size:0.9em"><i>inkl. 7% MwSt.</i></span>
          </v-col>
          <v-col cols="4" class="text-right">
            <span style="font-size:0.9em"><i> {{ mwst }} € </i></span>
          </v-col>

          <v-col cols="8">
            <span style="font-size:0.9em">Versandkosten:</span>
          </v-col>
          <v-col cols="4" class="text-right">
            <span style="font-size:0.9em">
              {{ this.$store.state.shippingCost.toFixed(2).replace(".", ",") }}
              €
            </span>
          </v-col>
        </v-row>

        <v-divider class="mt-6 mb-4"></v-divider>

        <v-row no-gutters>
          <v-col cols="8">
            <span class="font-weight-bold">Gesamtsumme: </span>
          </v-col>
          <v-col cols="4" class=" text-right">
            <span class="font-weight-bold">{{ total }} €</span>
          </v-col>

          
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkoutForm: null,
      nameRules: [],
      name: "",
      emailRules: [],
      email: ""
    };
  },
  methods: {},
  computed: {
    total() {
      // eslint-disable-next-line
      return (this.$store.state.cart.reduce((acc, product) => acc + (product.itemId.price * product.quantity), 0) + this.$store.state.shippingCost).toFixed(2).replace(".",",");
    },
    sum() {
      // eslint-disable-next-line
      return this.$store.state.cart.reduce((acc, product) => acc + (product.itemId.price * product.quantity), 0).toFixed(2).replace(".",",");
    },
    mwst() {
      // eslint-disable-next-line
      return ((this.$store.state.cart.reduce((acc, product) => acc + (product.itemId.price * product.quantity), 0))/1.07*0.07).toFixed(2).replace(".",",");
    }
  }
};
</script>
